import Vue from 'vue'
import Router from 'vue-router'
import Cabinet from "../components/pages/Cabinet";
import Login from "../components/pages/Login";
import Survey from "../components/pages/Survey";
import Finish from "../components/pages/Finish";
import Error from "../components/pages/Error";
import Admin from "../components/pages/Admin";
import Index from "../components/pages/Index";

import {store} from '../store';
import LoginWithoutCompany from "../components/pages/LoginWithoutCompany";
import NetworkError from "../components/pages/errors/NetworkError";

Vue.use(Router);

const ifNotAuthenticated = (to, from, next) => {
    console.log(store.getters.getIsForceLogout);
    if (store.getters.getIsForceLogout || !store.getters.getAccessToken) {
        next();
        return
    }
    next('/')
};

const ifAuthenticated = (to, from, next) => {
    if (store.getters.getAccessToken) {
        next();
        return
    }
    next('/login')
};

const ifAuthenticatedIndexRule = (to, from, next) => {
    if (store.getters.getAccessToken) {
        next('/cabinet');
        return
    }
    next();
};

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Index',
            component: Index,
            beforeEnter: ifAuthenticatedIndexRule
        },
        {
            path: '/cabinet',
            name: 'Cabinet',
            component: Cabinet,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/login/:uid',
            name: 'Login',
            component: Login,
            beforeEnter: ifNotAuthenticated
        },
        {
            path: '/login',
            name: 'Login',
            component: LoginWithoutCompany,
            beforeEnter: ifNotAuthenticated
        },
        {
            path: '/r/:uid',
            name: 'Survey',
            component: Survey
        },
        {
            path: '/finish/:uid',
            name: 'Finish',
            component: Finish
        },
        {
            path: '/error/:reason/:uid',
            name: 'Error',
            component: Error
        },
        {
            path: '/admin',
            name: 'Admin',
            component: Admin
        },
        {
            path: '/network-error',
            name: 'NetworkError',
            component: NetworkError
        }
    ]
})
